import { type Exporter, GENERATED_BY } from "./types";

export const ghostty: Exporter = {
  id: "ghostty",
  label: "Ghostty",
  app: true,
  description: "Theme file with the 16-color palette, background, cursor and selection.",
  run: (ctx) => {
    const { color, theme, appName } = ctx;
    const lines = [
      `# ${appName}: "${theme.name}" (${theme.variant}), ${GENERATED_BY}`,
      `background = ${color("terminal.background")}`,
      `foreground = ${color("terminal.foreground")}`,
      `cursor-color = ${color("terminal.cursor")}`,
      `cursor-text = ${color("terminal.cursorText")}`,
      `selection-background = ${color("terminal.selectionBg")}`,
      `selection-foreground = ${color("terminal.selectionFg")}`,
      ...Array.from({ length: 16 }, (_, i) => `palette = ${i}=${color(`terminal.ansi${i}`)}`),
    ];
    return {
      files: [
        {
          path: `~/.config/ghostty/themes/${appName}`,
          filename: appName,
          language: "ini",
          content: `${lines.join("\n")}\n`,
        },
      ],
      steps: [
        `Create \`~/.config/ghostty/themes/${appName}\` with the file below (make the \`themes\` directory if needed).`,
        `In \`~/.config/ghostty/config\`, set \`theme = ${appName}\`, replacing any existing \`theme = …\` line. Leave every other setting alone.`,
        "Reload the config: press `ctrl+shift+,` (Linux) or `cmd+shift+,` (macOS) in Ghostty, or restart it.",
      ],
      verify: [
        `ghostty +validate-config`,
        `ghostty +show-config | grep -E '^(theme|palette = 4=)'`,
      ],
      notes: [
        "Apps that use the terminal's ANSI colors (Cursor Agent, WeeChat's named colors, shell prompts, `ls`, `git`) pick these colors up automatically.",
      ],
    };
  },
};
